module.exports = __webpack_public_path__ + "assets/img/3202.bd46cb69.png";